import { ApplicationDataStore } from '@servicetitan/financing-application-shared';
import { useState, useEffect } from 'react';
import { SignatureDataStore, SignatureData } from '@servicetitan/financing-decision-shared';

export const useSignatureValidator = () => {
    const { setSignatureData } = SignatureDataStore.useStore();
    const {
        applicationData: { applicant, coApplicant },
    } = ApplicationDataStore.useStore();
    const [applicantSignature, setApplicantSignature] = useState('');
    const [coApplicantSignature, setCoApplicantSignature] = useState('');

    const applicantFullName = `${applicant.primaryApplicant?.firstName} ${applicant.primaryApplicant?.lastName}`;
    useEffect(() => {
        if (applicantSignature === applicantFullName) {
            setSignatureData((prev: SignatureData) => ({
                ...prev,
                applicantSignature,
            }));
        } else {
            setSignatureData((prev: SignatureData) => ({
                ...prev,
                applicantSignature: '',
            }));
        }
    }, [applicantFullName, applicantSignature, setSignatureData]);

    const coApplicantFullName =
        coApplicant.hasCoApplicant &&
        `${coApplicant.coApplicant?.firstName} ${coApplicant.coApplicant?.lastName}`;
    useEffect(() => {
        if (coApplicantSignature === coApplicantFullName) {
            setSignatureData((prev: SignatureData) => ({
                ...prev,
                coApplicantSignature,
            }));
        } else {
            setSignatureData((prev: SignatureData) => ({
                ...prev,
                coApplicantSignature: '',
            }));
        }
    }, [coApplicantFullName, coApplicantSignature, setSignatureData]);

    return { setApplicantSignature, setCoApplicantSignature };
};
